// ==========================================================================
// main.tsx — app entry (FF-002, 9 Oct 2026)
// Fonts are bundled with the app (not loaded from Google), so they work offline
// on the home-screen app and no outside site sees who opens it. (FF-022)
// ==========================================================================
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import { AuthProvider } from "./lib/auth";
import "@fontsource/plus-jakarta-sans/400.css";
import { applyTheme, THEMES, type Theme } from "./lib/household";
import { startAppearance } from "./lib/appearance";
import "./lib/pwa";

// The login's colour theme, remembered in this browser so it shows before the data loads (FF-040).
try { const t = localStorage.getItem("theme"); if (THEMES.some((x) => x.key === t)) applyTheme(t as Theme); } catch { /* fine */ }
// Light or dark for this device (FF-058).
startAppearance();
import "@fontsource/plus-jakarta-sans/500.css";
import "@fontsource/plus-jakarta-sans/600.css";
import "@fontsource/plus-jakarta-sans/700.css";
import "@fontsource/cinzel/600.css";
import "@fontsource/caveat/500.css";
import "@fontsource/caveat/700.css";
import "./index.css";

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
